import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form/immutable';

import Input from '../common/Input';
import { validations, login } from '../../utils/constraints';

const LoginForm = ({ handleSubmit, error, submitting }) => (
  <form onSubmit={handleSubmit}>
    {error && <div className="error-message">{error}</div>}
    <div>
      <Field
        name="email"
        type="email"
        placeholder="Email"
        icon="person"
        component={Input}
      />
    </div>
    <div>
      <Field
        name="password"
        type="password"
        placeholder="Contraseña"
        icon="lock"
        component={Input}
      />
    </div>
    <button
      className={`default-button ${submitting ? 'loading-button' : ''}`}
      type="submit"
    >
      {submitting ? 'Ingresando...' : 'Ingresar'}
    </button>
  </form>
);

const { func, string, bool } = PropTypes;

LoginForm.propTypes = {
  handleSubmit: func.isRequired,
  error: string,
  submitting: bool
};

export default reduxForm({
  form: 'login',
  validate: validations(login)
})(LoginForm);



// WEBPACK FOOTER //
// ./src/components/session/LoginForm.js